import { constructEnum } from '@/lib/enum';

export default constructEnum('ReviewVendor', {
  BRANDI: 'brandi',
  HIVER: 'hiver',
  PLARE: 'plare',
  REVU_SELECT: 'revu_select',
  GLOWPICK: 'glowpick',
  REVU: 'revu',
  ZIGZAG: 'zigzag',
  TAG_BY: 'tag_by',
  ELEVEN_ST: '11st',
  AUCTION: 'auction',
  CJ_ON_STYLE: 'cj_on_style',
  COUPANG: 'coupang',
  FUNSHOP: 'funshop',
  GMARKET: 'gmarket',
  IDUS: 'idus',
  KAKAO_MAKERS: 'kakao_makers',
  LOTTEON: 'lotteon',
  MUSINSA: 'musinsa',
  NAVER_SHOPING: 'naver_shoping',
  OHOUSE: 'ohouse',
  OLIVE_YOUNG: 'olive_young',
  SMARTSTORE: 'smart_store',
  SSG: 'ssg',
  TALK_STORE: 'talk_store',
  TEN_BY_TEN: 'ten_by_ten',
  WADIZ: 'wadiz',
  WEMAPE: 'wemape',
  MPETFRIENDS: 'mpetfriends',
  GSSHOP: 'gsshop',
  HANKKI_MARKET: 'hankki_market',
  RANKINGDAK: 'rankingdak',
  HALFCLUB: 'halfclub',
  HMALL: 'hmall',
  LOTTEIMALL: 'lotteimall',
  LFMALL: 'lfmall',
  SKSTOA: 'skstoa',
  QUEENIT: 'queenit',
  NAVER_BRAND_STORE: 'naver_brand_store',
  WCONCEPT: 'wconcept',
  TWENTY_NINE_CM: '29cm',
  GIFTKAKAO: 'giftkakao',
  INTERPARK: 'interpark',
  GETTT: 'gettt',
  KURLY: 'kurly',
  ALLETS: 'allets',
  GGUMIM: 'ggumim',
  TMON: 'tmon'
});
